import Vue from "vue";
import Vuex from "vuex";

import vuexORM from "./plugins/vuex-orm";

import user from "./modules/user";
import series from "./modules/series";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { user, series },
  plugins: [vuexORM],
});
